/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

// Material Dashboard 2 React Context Provider
import { MaterialUIControllerProvider } from "context";
import { SnackbarProvider } from "notistack";
import { SnackbarProvider as CustomSnackbarProvider } from "./components/SnackBarContext";
import { Provider } from "react-redux";
import store from "./redux/Store/store";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
const container = document.getElementById("app");
const root = createRoot(container);
const persistor = persistStore(store);
root.render(
  <SnackbarProvider
    maxSnack={3}
    anchorOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
  >
    <CustomSnackbarProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <MaterialUIControllerProvider>
              <App />
            </MaterialUIControllerProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </CustomSnackbarProvider>
  </SnackbarProvider>
);
